var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',[_c('nav',[_c('ul',_vm._l((_vm.menus),function(menu,index){return _c('li',{key:index},[_c('router-link',{class:{'current': _vm.activeIndex === index},attrs:{"to":menu.path},nativeOn:{"click":function($event){return _vm.change(index)}}},[_vm._v("\n            "+_vm._s(menu.pageName)+"\n        ")])],1)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66562cd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu.vue
// module id = null
// module chunks = 